module.exports = __webpack_public_path__ + "static/media/KW900-02-15.148d5a71.JPG";